import DownloadResumeModal from "./DownloadResumeModal";

export default DownloadResumeModal;
